import { ModalItem } from './ItemModal'
import * as T from '../../components/Table'
import { Flex, Input } from '@chakra-ui/react'
import { useState, useMemo } from 'react'

export function ListModal({ list }) {
  const [search, setSearch] = useState('')

  function debounce(func, timeout = 300) {
    let timer
    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        func.apply(this, args)
      }, timeout)
    }
  }

  const handleInputValueChange = debounce((e) => {
    setSearch(e.target.value)
  })

  const filteredList = useMemo(() => {
    return list?.filter((item) => {
      return (
        item.nome_cliente.toLowerCase().includes(search.toLowerCase()) ||
        item.email_contato.toLowerCase().includes(search.toLowerCase())
      )
    })
  }, [list, search])

  return (
    <>
      <T.Tr>
        <Flex my={1}>
          <Input
            placeholder="Pesquisar por nome ou e-mail"
            size="sm"
            onChange={handleInputValueChange}
          />
        </Flex>
      </T.Tr>
      {filteredList?.map((item, index) => (
        <ModalItem key={index} item={item} />
      ))}
    </>
  )
}
